import {
  Package,
  UtensilsCrossed,
  Truck,
  Calendar,
  Trash2,
  Users,
  Sparkles,
} from 'lucide-react';
import type { ToolCategory } from './types';

export const CATEGORY_CONFIG: Readonly<Record<ToolCategory, Readonly<{
  icon: typeof Package;
  label: string;
}>>> = {
  inventory: {
    icon: Package,
    label: 'Inventory',
  },
  recipes: {
    icon: UtensilsCrossed,
    label: 'Recipes',
  },
  orders: {
    icon: Truck,
    label: 'Orders',
  },
  menus: {
    icon: Calendar,
    label: 'Menus',
  },
  waste: {
    icon: Trash2,
    label: 'Waste',
  },
  suppliers: {
    icon: Users,
    label: 'Suppliers',
  },
  general: {
    icon: Sparkles,
    label: 'General',
  },
};

export const SUGGESTED_QUESTIONS: readonly string[] = [
  'What items are low in stock?',
  'When will the salmon order arrive?',
  'What can I substitute for heavy cream?',
  'Show me vegetarian recipes',
];
